import { render, staticRenderFns } from "./CustomDetails.vue?vue&type=template&id=b1886b38&scoped=true&"
import script from "./CustomDetails.vue?vue&type=script&lang=js&"
export * from "./CustomDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomDetails.vue?vue&type=style&index=0&id=b1886b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1886b38",
  null
  
)

export default component.exports